import { FC } from 'react';

import { CurrencyConnected } from '@pp/core/src/components/currency/CurrencyConnected';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { truncateToTwoDecimal } from '../../../../../config/utils';
import { SingleMultiplier } from '../../../../tableSheet/singleMultiplier/SingleMultiplier';

import styles from './CashedMultipliersAndWinTopBar.module.css';

export interface CashedMultipliersAndWinTopBarProps {
  currentTab?: string;
  betAmount: number;
  winAmount: number;
  multiplier: number;
  showStaticData?: boolean;
}

export const CashedMultipliersAndWinTopBar: FC<CashedMultipliersAndWinTopBarProps> = ({
  currentTab,
  betAmount,
  winAmount,
  multiplier,
  showStaticData = false,
}) => {
  const container_mods = useModifiers(styles, 'singleItem_win_top_bar', { container: !!currentTab });
  const multiplier_mods = useModifiers(styles, 'win_topBar', { multiplier: !!currentTab });
  const betWin_mods = useModifiers(styles, 'win_topBar', { betWin_box: !!currentTab });

  return (
    <div className={`${styles.singleItem_top_bar_container} ${container_mods}`}>
      <div className={`${styles.topBar_multiplier} ${multiplier_mods}`}>
        <SingleMultiplier value={multiplier} />
      </div>
      <div className={`${styles.topBar_betWin_box} ${betWin_mods}`}>
        <div>
          <span>
            {showStaticData ? 'Bet' : <L10nText tk={'BETLABEL'} />}:<span>&nbsp;</span>
          </span>
          <span className={styles.betAmount}>
            <CurrencyConnected value={betAmount} />
          </span>
        </div>
        <div>
          {!currentTab && (
            <span>
              {showStaticData ? 'Win' : <L10nText tk={'WIN'} />}:<span>&nbsp;</span>
            </span>
          )}
          <span className={styles.wonAmount}>
            <CurrencyConnected value={truncateToTwoDecimal(winAmount)} />
          </span>
        </div>
      </div>
    </div>
  );
};
